// @flow
import type { Reducer } from 'redux';

import type { Action } from '../types';

function checkActionByPredicate<T, A: Action<T>>(
  predicate: string | string[] | ((action: A) => boolean),
  action: A,
) {
  if (typeof predicate === 'function') {
    return predicate(action);
  }
  if (!action.type) {
    return false;
  }
  if (typeof predicate === 'string') {
    return action.type === predicate;
  }
  if (Array.isArray(predicate)) {
    return predicate.includes(action.type);
  }

  return false;
}

export function clearableReducer<S, T, A: Action<T>>(
  predicate: string | string[] | ((action: A) => boolean),
  reducer: Reducer<S, A>,
) {
  return (state: S, action: A) =>
    reducer(checkActionByPredicate(predicate, action) ? undefined : state, action);
}

export default clearableReducer;



// WEBPACK FOOTER //
// ./src/store/helpers/clearableReducer.js